import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";

function Returns() {
  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />

      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Returns & Exchanges</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte">
            <p>
              <strong>Returns Policy</strong>
            </p>
            <p>
              We want you to be completely satisfied with your Bernicemy
              purchase. If for any reason you are not satisfied, we gladly
              accept returns within 30 days of the original purchase date for a
              full refund or exchange.
            </p>
            <p>
              <strong>Return Requirements</strong>
            </p>
            <p>
              To be eligible for a return, items must meet the following
              conditions:
            </p>
            <ul>
              <li>Items must be unworn, unwashed, and in original condition</li>
              <li>All original tags must be attached</li>
              <li>Items must be returned in their original packaging</li>
              <li>Returns must be initiated within 30 days of delivery</li>
              <li>
                Sale items and gift cards are final sale and cannot be returned
              </li>
            </ul>
            <p>
              <strong>How to Return</strong>
            </p>
            <p>To initiate a return, please follow these steps:</p>
            <ul>
              <li>
                Contact our customer service team at{" "}
                <a href="mailto:shop@bernicemy.blog">shop@bernicemy.blog</a> or
                call 1-877-757-3934
              </li>
              <li>
                Provide your order number and the item(s) you wish to return
              </li>
              <li>We will send you a prepaid return shipping label</li>
              <li>
                Pack your items securely with all original tags and packaging
              </li>
              <li>Drop off your package at any authorized shipping location</li>
            </ul>
            <p>
              <strong>Exchanges</strong>
            </p>
            <p>
              We are happy to exchange items for a different size or color. To
              request an exchange, please contact our customer service team.
              Exchanges are subject to availability.
            </p>
            <p>
              <strong>Refund Processing</strong>
            </p>
            <p>
              Once we receive your return, please allow 5-7 business days for
              processing. Refunds will be issued to the original payment method
              used for the purchase. Please note that it may take an additional
              5-10 business days for the refund to appear in your account,
              depending on your financial institution.
            </p>
            <p>
              <strong>Try Before You Buy</strong>
            </p>
            <p>
              We offer a Try Before You Buy program where you can order up to 5
              items to try at home. You'll have 7 days to decide what to keep.
              Only pay for what you keep, and return the rest using the prepaid
              shipping label.
            </p>
            <p>
              <strong>Damaged or Defective Items</strong>
            </p>
            <p>
              If you receive a damaged or defective item, please contact us
              immediately at{" "}
              <a href="mailto:shop@bernicemy.blog">shop@bernicemy.blog</a> with
              photos of the damage. We will arrange for a replacement or full
              refund at no cost to you.
            </p>
            <p>
              <strong>International Returns</strong>
            </p>
            <p>
              International customers are responsible for return shipping costs.
              Please contact our customer service team for instructions on
              returning international orders. Customs duties and taxes are
              non-refundable.
            </p>
            <p>
              <strong>Questions?</strong>
            </p>
            <p>
              If you have any questions about our returns policy, please don't
              hesitate to contact us:
            </p>
            Bernicemy, Inc. <br />
            114 North Court Street <br />
            Florence, AL 35630 <br />
            USA <br />
            <br />
            Email: <a href="mailto:shop@bernicemy.blog">
              shop@bernicemy.blog
            </a>{" "}
            <br />
            Phone: 1-877-757-3934
          </div>
        </div>
      </div>

      <Footer />
    </body>
  );
}

export default Returns;
